import React, { useState, useEffect } from 'react';
import ExcelJS from 'exceljs';
import './Admin.css';

const QuanLyKho = () => {
  const [khoHangData, setKhoHangData] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    MaCH: '',
    NgayBatDau: '',
    NgayKetThuc: ''
  });
  const [error, setError] = useState('');
  // Add new state variables for stores and categories
  const [stores, setStores] = useState([]);
  const [storesLoading, setStoresLoading] = useState(false);
  const [categories, setCategories] = useState({});
  const [groupedData, setGroupedData] = useState({});
  const [filterType, setFilterType] = useState('ALL'); // ALL | NGUYENLIEU | THANHPHAM
  const [showSplitXuat, setShowSplitXuat] = useState(false);
  const [showSplitGiaTriXuat, setShowSplitGiaTriXuat] = useState(false);
  // Add new state variables for transfer data
  const [transferData, setTransferData] = useState([]);
  const [showSplitNhap, setShowSplitNhap] = useState(false);
  const [showSplitGiaTriNhap, setShowSplitGiaTriNhap] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [banhKemData, setBanhKemData] = useState([]); // Thêm state cho dữ liệu bánh kem
  const [banhKemLoading, setBanhKemLoading] = useState(false);

  // Fetch stores when component mounts
  useEffect(() => {
    fetchStores();
  }, []);

  // Hàm gọi API lấy danh sách cửa hàng
  const fetchStores = async () => {
    setStoresLoading(true);
    try {
      const response = await fetch(`https://doticom.vn:3000/stores`);
      if (response.ok) {
        const storesData = await response.json();
        setStores(storesData);
      } else {
        console.error("Không thể tải danh sách cửa hàng");
      }
    } catch (err) {
      console.error("Lỗi khi tải danh sách cửa hàng:", err);
    } finally {
      setStoresLoading(false);
    }
  };

  // Hàm gọi API lấy tên danh mục
  const fetchCategoryName = async (maNLSP) => {
    try {
      const response = await fetch(`https://doticom.vn:3000/categories/${maNLSP}`);
      if (response.ok) {
        const result = await response.json();
        if (result.length > 0) {
          return result[0].TenLoaiSP;
        }
      }
      return "Không xác định";
    } catch (err) {
      console.error(`Lỗi khi lấy tên danh mục cho ${maNLSP}:`, err);
      return "Không xác định";
    }
  };

  // Hàm gọi API lấy dữ liệu điều chuyển kho
  const fetchTransferData = async () => {
    if (!filters.MaCH || !filters.NgayBatDau || !filters.NgayKetThuc) {
      return [];
    }

    try {
      const queryParams = new URLSearchParams({
        TuNgay: filters.NgayBatDau,
        DenNgay: filters.NgayKetThuc
      });
      const response = await fetch(`https://doticom.vn:5000/api/DieuChuyenKho/store/${filters.MaCH}?${queryParams}`);
      const result = await response.json();

      if (result.data) {
        return result.data;
      }
      return [];
    } catch (err) {
      console.error('Lỗi khi tải dữ liệu điều chuyển:', err);
      return [];
    }
  };

  // Hàm tính toán dữ liệu điều chuyển cho từng sản phẩm
  const getTransferDataForProduct = (maNL) => {
    const productTransfers = transferData.filter(transfer => transfer.maSP === maNL);
    
    let nhapDieuChuyen = 0;
    let xuatDieuChuyen = 0;
    let giaTriNhapDieuChuyen = 0;
    let giaTriXuatDieuChuyen = 0;

    productTransfers.forEach(transfer => {
      // Use soLuongXacNhan if not null, otherwise use soLuongDieuChuyen
      const soLuong = transfer.soLuongXacNhan !== null ? transfer.soLuongXacNhan : transfer.soLuongDieuChuyen;
      // Use thanhTienXacNhan if soLuongXacNhan is used, otherwise use thanhTien
      const thanhTien = transfer.soLuongXacNhan !== null ? transfer.thanhTienXacNhan : transfer.thanhTien;
      
      if (transfer.direction === 2) { // Nhận về
        nhapDieuChuyen += soLuong || 0;
        giaTriNhapDieuChuyen += thanhTien || 0;
      } else if (transfer.direction === 1) { // Chuyển đi
        xuatDieuChuyen += soLuong || 0;
        giaTriXuatDieuChuyen += thanhTien || 0;
      }
    });

    return {
      nhapDieuChuyen,
      xuatDieuChuyen,
      giaTriNhapDieuChuyen,
      giaTriXuatDieuChuyen
    };
  };

  // Hàm gọi API lấy dữ liệu kho hàng (cập nhật)
  const fetchKhoHangData = async () => {
    if (!filters.MaCH || !filters.NgayBatDau || !filters.NgayKetThuc) {
      setError('Vui lòng nhập đầy đủ Mã cửa hàng, Ngày bắt đầu và Ngày kết thúc');
      return;
    }

    setLoading(true);
    setError('');
    
    try {
      // Fetch both inventory and transfer data
      const [inventoryResponse, transferDataResult] = await Promise.all([
        fetch(`https://doticom.vn:3000/api/khohang?${new URLSearchParams(filters)}`),
        fetchTransferData()
      ]);

      const inventoryResult = await inventoryResponse.json();
      setTransferData(transferDataResult);

      if (inventoryResult.success) {
        // Process the data to group by MaNLSP
        const data = inventoryResult.data;
        
        // Create object to store category names
        const categoryNames = {};
        // Group data by MaNLSP
        const grouped = {};
        
        // Get unique MaNLSP values
        const uniqueCategories = [...new Set(data.map(item => item.MaNLSP))];
        
        // Fetch category names for all unique MaNLSP values
        await Promise.all(uniqueCategories.map(async (maNLSP) => {
          if (maNLSP) {
            const categoryName = await fetchCategoryName(maNLSP);
            categoryNames[maNLSP] = categoryName;
            
            // Initialize category group
            grouped[maNLSP] = {
              name: categoryName,
              items: data.filter(item => item.MaNLSP === maNLSP)
            };
          }
        }));
        
        // Handle items with no category (null or undefined MaNLSP)
        const uncategorizedItems = data.filter(item => !item.MaNLSP);
        if (uncategorizedItems.length > 0) {
          grouped["UNKNOWN"] = {
            name: "Chưa phân loại",
            items: uncategorizedItems
          };
        }
        
        setCategories(categoryNames);
        setGroupedData(grouped);
        setKhoHangData(data);
        setSummary(inventoryResult.summary);
      } else {
        setError(inventoryResult.message || 'Có lỗi xảy ra khi tải dữ liệu');
      }
    } catch (err) {
      setError('Lỗi kết nối server');
      console.error('Error fetching data:', err);
    } finally {
      setLoading(false);
    }
  };

  // Hàm lấy dữ liệu XNT bánh kem
  const fetchBanhKemData = async () => {
    if (!filters.MaCH || !filters.NgayBatDau || !filters.NgayKetThuc) {
      setBanhKemData([]);
      return;
    }
    setBanhKemLoading(true);
    try {
      const response = await fetch(
        `https://doticom.vn:3000/xntBanhKem?fromDate=${filters.NgayBatDau}&toDate=${filters.NgayKetThuc}&maCH=${filters.MaCH}`
      );
      if (response.ok) {
        const result = await response.json();
        if (result.length > 0 && result[0].Data) {
          setBanhKemData(result[0].Data);
        } else {
          setBanhKemData([]);
        }
      } else {
        setBanhKemData([]);
      }
    } catch (err) {
      setBanhKemData([]);
    } finally {
      setBanhKemLoading(false);
    }
  };

  // Fetch data when filter or date range changes
  useEffect(() => {
    if (filterType === 'BANHKEM') {
      fetchBanhKemData();
    }
    // eslint-disable-next-line
  }, [filterType, filters.MaCH, filters.NgayBatDau, filters.NgayKetThuc]);

  // Hàm xử lý thay đổi filter
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Hàm format số
  const formatNumber = (num) => {
    return new Intl.NumberFormat('vi-VN').format(num || 0);
  };

  // Hàm format tiền tệ
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('vi-VN', {
      style: 'currency',
      currency: 'VND'
    }).format(amount || 0);
  };

  // Hàm xuất Excel (mock)
  const handleExportExcel = () => {
    // TODO: Implement Excel export functionality
    alert('Tính năng xuất Excel đang được phát triển');
  };

  // Hàm xuất 1 sheet excel cho nhóm dữ liệu truyền vào
  const exportSheet = (workbook, sheetName, groupKeys) => {
    const worksheet = workbook.addWorksheet(sheetName);

    worksheet.columns = [
      { width: 8 },   // STT
      { width: 15 },  // Mã sản phẩm
      { width: 35 },  // Tên sản phẩm
      { width: 20 },  // Danh mục
      { width: 10 },  // ĐVT
      { width: 15 },  // Đơn giá
      { width: 12 },  // Nhập - Số lượng
      { width: 15 },  // Nhập - Giá trị
      { width: 12 },  // Xuất - Số lượng
      { width: 15 },  // Xuất - Giá trị
      { width: 12 },  // Tồn - Số lượng
      { width: 15 }   // Tồn - Giá trị
    ];

    worksheet.mergeCells('A1:L1');
    const titleCell = worksheet.getCell('A1');
    titleCell.value = `BẢNG TỔNG HỢP NHẬP XUẤT TỒN - ${sheetName}`;
    titleCell.font = { size: 16, bold: true };
    titleCell.alignment = { horizontal: 'center', vertical: 'middle' };

    worksheet.mergeCells('A2:L2');
    const dateCell = worksheet.getCell('A2');
    dateCell.value = `Từ ngày ${filters.NgayBatDau} đến ngày ${filters.NgayKetThuc}`;
    dateCell.font = { size: 12, italic: true };
    dateCell.alignment = { horizontal: 'center', vertical: 'middle' };

    worksheet.addRow([]);

    const headerRow1 = worksheet.addRow([
      'STT', 'Mã sản phẩm', 'Tên sản phẩm', 'Danh mục', 'ĐVT', 'Đơn giá',
      'Nhập', '', 'Xuất', '', 'Tồn', ''
    ]);
    worksheet.mergeCells('G4:H4'); // Nhập
    worksheet.mergeCells('I4:J4'); // Xuất
    worksheet.mergeCells('K4:L4'); // Tồn

    const headerRow2 = worksheet.addRow([
      '', '', '', '', '', '',
      'Số lượng', 'Giá trị', 'Số lượng', 'Giá trị', 'Số lượng', 'Giá trị'
    ]);

    [headerRow1, headerRow2].forEach(row => {
      row.font = { bold: true };
      row.alignment = { horizontal: 'center', vertical: 'middle' };
      row.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFE6E6FA' }
      };
    });

    for (let col = 1; col <= 12; col++) {
      ['A4', 'B4', 'C4', 'D4', 'E4', 'F4', 'G4', 'H4', 'I4', 'J4', 'K4', 'L4',
       'A5', 'B5', 'C5', 'D5', 'E5', 'F5', 'G5', 'H5', 'I5', 'J5', 'K5', 'L5'].forEach(cell => {
        worksheet.getCell(cell).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
    }

    let currentRow = 6;
    let itemIndex = 0;

    // Tính tổng cho sheet
    let totalTongNhap = 0, totalGiaTriNhap = 0, totalTongXuat = 0, totalGiaTriXuat = 0, totalTonCK = 0, totalGiaTriCK = 0;

    groupKeys.forEach(maNLSP => {
      const categoryGroup = groupedData[maNLSP];
      if (!categoryGroup) return;

      const groupRow = worksheet.addRow(['', '', categoryGroup.name, '', '', '', '', '', '', '', '', '']);
      groupRow.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFEEF0F5' }
      };
      groupRow.font = { bold: true };
      worksheet.mergeCells(`A${currentRow}:L${currentRow}`);
      groupRow.alignment = { horizontal: 'center' };
      currentRow++;

      categoryGroup.items.forEach((item) => {
        itemIndex++;
        const donGia = item.TonCK > 0 ? item.GiaTriCK / item.TonCK : 
                      (item.TongNhap > 0 ? item.GiaTriNhap / item.TongNhap : 0);

        // Calculate transfer data for the item
        const transferInfo = getTransferDataForProduct(item.MaNL);

        // Combined values to match table display
        const combinedTongNhap = (item.TongNhap || 0) + transferInfo.nhapDieuChuyen;
        const combinedGiaTriNhap = (item.GiaTriNhap || 0) + transferInfo.giaTriNhapDieuChuyen;
        const combinedTongXuat = (item.TongXuat || 0) + (item.TongHuy || 0) + transferInfo.xuatDieuChuyen;
        const combinedGiaTriXuat = (item.GiaTriXuat || 0) + (item.GiaTriHuy || 0) + transferInfo.giaTriXuatDieuChuyen;

        worksheet.addRow([
          itemIndex,
          item.MaNL,
          item.Ten_SP,
          categoryGroup.name,
          item.DVT_SP,
          donGia,
          combinedTongNhap,
          combinedGiaTriNhap,
          combinedTongXuat,
          combinedGiaTriXuat,
          item.TonCK || 0,
          item.GiaTriCK || 0
        ]).eachCell((cell, colNumber) => {
          if (colNumber >= 6 && colNumber <= 12) cell.numFmt = '#,##0.0000'; // Show up to 4 decimals for precision
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          };
          if (colNumber === 1 || colNumber === 2) cell.alignment = { horizontal: 'center' };
          if (colNumber === 5) cell.alignment = { horizontal: 'center' };
          if (colNumber >= 6 && colNumber <= 12) cell.alignment = { horizontal: 'right' };
        });

        // Update totals with combined values
        totalTongNhap += combinedTongNhap;
        totalGiaTriNhap += combinedGiaTriNhap;
        totalTongXuat += combinedTongXuat;
        totalGiaTriXuat += combinedGiaTriXuat;
        totalTonCK += item.TonCK || 0;
        totalGiaTriCK += item.GiaTriCK || 0;

        currentRow++;
      });
    });

    // Hàng tổng sheet
    const totalRow = worksheet.addRow([
      '', '', 'TỔNG CỘNG', '', '', '',
      totalTongNhap,
      totalGiaTriNhap,
      totalTongXuat,
      totalGiaTriXuat,
      totalTonCK,
      totalGiaTriCK
    ]);
    totalRow.font = { bold: true };
    totalRow.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFFFD700' }
    };
    for (let col = 7; col <= 12; col++) totalRow.getCell(col).numFmt = '#,##0.0000'; // Match decimal format
    for (let col = 1; col <= 12; col++) {
      totalRow.getCell(col).border = {
        top: { style: 'thick' },
        left: { style: 'thin' },
        bottom: { style: 'thick' },
        right: { style: 'thin' }
      };
    }
    totalRow.getCell(3).alignment = { horizontal: 'center' };
    for (let col = 7; col <= 12; col++) totalRow.getCell(col).alignment = { horizontal: 'right' };
  };

  // Hàm xuất 1 sheet excel cho dữ liệu bánh kem
  const exportBanhKemSheet = (workbook, sheetName, data) => {
    const worksheet = workbook.addWorksheet(sheetName);

    worksheet.columns = [
      { width: 8 },   // STT
      { width: 15 },  // Mã SP
      { width: 15 },  // Tồn đầu kỳ
      { width: 15 },  // Nhập điều phối
      { width: 15 },  // Nhập điều chuyển
      { width: 15 },  // Xuất bán
      { width: 15 },  // Xuất điều chuyển
      { width: 15 },  // Tổng xuất
      { width: 15 }   // Tồn cuối kỳ
    ];

    worksheet.mergeCells('A1:I1');
    const titleCell = worksheet.getCell('A1');
    titleCell.value = `BÁO CÁO XNT BÁNH KEM - ${sheetName}`;
    titleCell.font = { size: 16, bold: true };
    titleCell.alignment = { horizontal: 'center', vertical: 'middle' };

    worksheet.mergeCells('A2:I2');
    const dateCell = worksheet.getCell('A2');
    dateCell.value = `Từ ngày ${filters.NgayBatDau} đến ngày ${filters.NgayKetThuc}`;
    dateCell.font = { size: 12, italic: true };
    dateCell.alignment = { horizontal: 'center', vertical: 'middle' };

    worksheet.addRow([]);

    const headerRow = worksheet.addRow([
      'STT', 'Mã SP', 'Tồn đầu kỳ', 'Nhập điều phối', 'Nhập điều chuyển', 'Xuất bán', 'Xuất điều chuyển', 'Tổng xuất', 'Tồn cuối kỳ'
    ]);
    headerRow.font = { bold: true };
    headerRow.alignment = { horizontal: 'center', vertical: 'middle' };
    headerRow.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFE6E6FA' }
    };

    for (let col = 1; col <= 9; col++) {
      ['A3', 'B3', 'C3', 'D3', 'E3', 'F3', 'G3', 'H3', 'I3'].forEach(cell => {
        worksheet.getCell(cell).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
    }

    let currentRow = 4;
    let totalTonDauKy = 0, totalNhapDieuPhoi = 0, totalNhapDieuChuyen = 0, totalXuatBan = 0, totalXuatDieuChuyen = 0, totalTongXuat = 0, totalTon = 0;

    data.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.MaSP,
        item.TonDauKy || 0,
        item.NhapDieuPhoi || 0,
        item.NhapDieuChuyen || 0,
        item.XuatBan || 0,
        item.XuatDieuChuyen || 0,
        item.TongXuat || 0,
        item.Ton || 0
      ]).eachCell((cell, colNumber) => {
        if (colNumber >= 3 && colNumber <= 9) cell.numFmt = '#,##0';
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        if (colNumber === 1 || colNumber === 2) cell.alignment = { horizontal: 'center' };
        if (colNumber >= 3 && colNumber <= 9) cell.alignment = { horizontal: 'right' };
      });

      totalTonDauKy += item.TonDauKy || 0;
      totalNhapDieuPhoi += item.NhapDieuPhoi || 0;
      totalNhapDieuChuyen += item.NhapDieuChuyen || 0;
      totalXuatBan += item.XuatBan || 0;
      totalXuatDieuChuyen += item.XuatDieuChuyen || 0;
      totalTongXuat += item.TongXuat || 0;
      totalTon += item.Ton || 0;

      currentRow++;
    });

    // Hàng tổng
    const totalRow = worksheet.addRow([
      '', 'TỔNG CỘNG', totalTonDauKy, totalNhapDieuPhoi, totalNhapDieuChuyen, totalXuatBan, totalXuatDieuChuyen, totalTongXuat, totalTon
    ]);
    totalRow.font = { bold: true };
    totalRow.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFFFD700' }
    };
    for (let col = 3; col <= 9; col++) totalRow.getCell(col).numFmt = '#,##0';
    for (let col = 1; col <= 9; col++) {
      totalRow.getCell(col).border = {
        top: { style: 'thick' },
        left: { style: 'thin' },
        bottom: { style: 'thick' },
        right: { style: 'thin' }
      };
    }
    totalRow.getCell(2).alignment = { horizontal: 'center' };
    for (let col = 3; col <= 9; col++) totalRow.getCell(col).alignment = { horizontal: 'right' };
  };

  // Hàm xuất Phiếu tổng hợp nhập xuất tồn (cập nhật để bao gồm bánh kem nếu có)
  const exportTongHopNhapXuatTon = async () => {
    if (khoHangData.length === 0 && banhKemData.length === 0) {
      alert('Không có dữ liệu để xuất báo cáo');
      return;
    }

    const workbook = new ExcelJS.Workbook();

    // Xuất sheet bánh kem nếu có dữ liệu
    if (banhKemData.length > 0) {
      exportBanhKemSheet(workbook, 'Kho bánh kem', banhKemData);
    }

    // Xuất các sheet kho hàng nếu có dữ liệu
    if (khoHangData.length > 0) {
      const nguyenLieuKeys = Object.keys(groupedData).filter(
        key =>
          groupedData[key].name === 'Nguyên Vật Liệu Bánh Mì' ||
          groupedData[key].name === 'Nguyên Liệu'
      );
      const thanhPhamKeys = Object.keys(groupedData).filter(
        key =>
          groupedData[key].name !== 'Nguyên Vật Liệu Bánh Mì' &&
          groupedData[key].name !== 'Nguyên Liệu' &&
          groupedData[key].name !== 'Chưa phân loại'
      );

      exportSheet(workbook, 'Kho nguyên liệu', nguyenLieuKeys);
      exportSheet(workbook, 'Kho thành phẩm', thanhPhamKeys);
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { 
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `TongHopNhapXuatTon_${filters.MaCH}_${filters.NgayBatDau}_${filters.NgayKetThuc}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  // Hàm lọc nhóm theo filterType
  const getFilteredGroupKeys = () => {
    if (filterType === 'ALL') return Object.keys(groupedData);
    if (filterType === 'NGUYENLIEU') {
      return Object.keys(groupedData).filter(
        key =>
          groupedData[key].name === 'Nguyên Vật Liệu Bánh Mì' ||
          groupedData[key].name === 'Nguyên Liệu' ||
          groupedData[key].name === 'Chưa phân loại' // Thêm dòng này để đưa "Chưa phân loại" vào nhóm nguyên liệu
      );
    }
    if (filterType === 'THANHPHAM') {
      return Object.keys(groupedData).filter(
        key =>
          groupedData[key].name !== 'Nguyên Vật Liệu Bánh Mì' &&
          groupedData[key].name !== 'Nguyên Liệu' &&
          groupedData[key].name !== 'Bánh kem' &&
          groupedData[key].name !== 'Chưa phân loại' // Đảm bảo không đưa "Chưa phân loại" vào thành phẩm
      );
    }
    return Object.keys(groupedData);
  };

  // Tính toán lại tổng theo filterType (cập nhật để bao gồm điều chuyển)
  const filteredSummary = (() => {
    const keys = getFilteredGroupKeys();
    let totalItems = 0,
      totalTongNhap = 0,
      totalGiaTriNhap = 0,
      totalTongXuat = 0,
      totalGiaTriXuat = 0,
      totalTonCK = 0,
      totalGiaTriCK = 0,
      totalNhapDieuChuyen = 0,
      totalGiaTriNhapDieuChuyen = 0,
      totalXuatDieuChuyen = 0,
      totalGiaTriXuatDieuChuyen = 0;

    keys.forEach(key => {
      const group = groupedData[key];
      if (!group) return;
      totalItems += group.items.length;
      
      group.items.forEach(item => {
        totalTongNhap += item.TongNhap || 0;
        totalGiaTriNhap += item.GiaTriNhap || 0;
        totalTongXuat += item.TongXuat || 0;
        totalGiaTriXuat += item.GiaTriXuat || 0;
        totalTonCK += item.TonCK || 0;
        totalGiaTriCK += item.GiaTriCK || 0;

        // Add transfer data
        const transferInfo = getTransferDataForProduct(item.MaNL);
        totalNhapDieuChuyen += transferInfo.nhapDieuChuyen;
        totalGiaTriNhapDieuChuyen += transferInfo.giaTriNhapDieuChuyen;
        totalXuatDieuChuyen += transferInfo.xuatDieuChuyen;
        totalGiaTriXuatDieuChuyen += transferInfo.giaTriXuatDieuChuyen;
      });
    });
    
    return {
      totalItems,
      totalTongNhap,
      totalGiaTriNhap,
      totalTongXuat,
      totalGiaTriXuat,
      totalTonCK,
      totalGiaTriCK,
      totalNhapDieuChuyen,
      totalGiaTriNhapDieuChuyen,
      totalXuatDieuChuyen,
      totalGiaTriXuatDieuChuyen
    };
  })();

  // Hàm lọc sản phẩm theo searchText
  const filterItemsBySearch = (items) => {
    if (!searchText.trim()) return items;
    const lowerSearch = searchText.trim().toLowerCase();
    return items.filter(item =>
      (item.Ten_SP && item.Ten_SP.toLowerCase().includes(lowerSearch)) ||
      (item.MaNL && item.MaNL.toLowerCase().includes(lowerSearch))
    );
  };

  return (
    <div className="admin-layout">
      <div className="admin-main">
        {/* Header */}
        <div className="admin-header">
          <div className="header-left">
            <h1>Quản lý Kho hàng</h1>
            <p>Báo cáo tồn kho theo thời gian</p>
          </div>
          <div className="user-info">
            <div className="user-avatar">
              <i className="fa fa-warehouse"></i>
            </div>
            <span className="user-name">Quản lý Kho</span>
          </div>
        </div>

        {/* Content */}
        <div className="content-section">
          {/* Filters Card */}
          <div className="card">
            <div className="card-header">
              <h3>Bộ lọc báo cáo</h3>
            </div>
            <div className="card-body">
              {/* Thêm 3 nút lọc */}
              <div style={{ marginBottom: 16, display: 'flex', gap: 8 }}>
                <button
                  className={`btn btn-outline-primary${filterType === 'NGUYENLIEU' ? ' active' : ''}`}
                  type="button"
                  onClick={() => setFilterType('NGUYENLIEU')}
                >
                  Quản lý XNT nguyên liệu
                </button>
                <button
                  className={`btn btn-outline-success${filterType === 'THANHPHAM' ? ' active' : ''}`}
                  type="button"
                  onClick={() => setFilterType('THANHPHAM')}
                  style={{ border: '2px solid #28a745' }}
                >
                  Quản lý XNT thành phẩm
                </button>
                <button
                  className={`btn btn-outline-warning${filterType === 'BANHKEM' ? ' active' : ''}`}
                  type="button"
                  onClick={() => setFilterType('BANHKEM')}
                  style={{ border: '2px solid #ffc107', color: '#856404' }}
                >
                  Quản lý XNT bánh kem
                </button>
                <button
                  className={`btn btn-outline-secondary${filterType === 'ALL' ? ' active' : ''}`}
                  type="button"
                  onClick={() => setFilterType('ALL')}
                >
                  Hiện tất cả
                </button>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="MaCH">Cửa hàng</label>
                    <select
                      id="MaCH"
                      name="MaCH"
                      className="form-control"
                      value={filters.MaCH}
                      onChange={handleFilterChange}
                      disabled={storesLoading}
                    >
                      <option value="">-- Chọn cửa hàng --</option>
                      {stores.map(store => (
                        <option key={store.IDCH} value={store.IDCH}>
                          {store.TenCuaHang} ({store.IDCH})
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="NgayBatDau">Ngày bắt đầu</label>
                    <input
                      type="date"
                      id="NgayBatDau"
                      name="NgayBatDau"
                      className="form-control"
                      value={filters.NgayBatDau}
                      onChange={handleFilterChange}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="NgayKetThuc">Ngày kết thúc</label>
                    <input
                      type="date"
                      id="NgayKetThuc"
                      name="NgayKetThuc"
                      className="form-control"
                      value={filters.NgayKetThuc}
                      onChange={handleFilterChange}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label>&nbsp;</label>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button
                        className="btn btn-primary"
                        onClick={fetchKhoHangData}
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <i className="fa fa-spinner spinning me-1"></i>
                            Đang tải...
                          </>
                        ) : (
                          <>
                            <i className="fa fa-search me-1"></i>
                            Tìm kiếm
                          </>
                        )}
                      </button>
                      <button
                        className="btn btn-secondary"
                        onClick={exportTongHopNhapXuatTon}
                        disabled={!khoHangData.length && !banhKemData.length}
                        title="Xuất phiếu tổng hợp nhập xuất tồn"
                      >
                        <i className="fa fa-download me-1"></i>
                        Xuất Excel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              
              {error && (
                <div style={{ 
                  color: '#dc3545', 
                  background: '#f8d7da', 
                  border: '1px solid #f5c6cb',
                  padding: '12px',
                  borderRadius: '4px',
                  marginTop: '16px'
                }}>
                  <i className="fa fa-exclamation-triangle me-1"></i>
                  {error}
                </div>
              )}
            </div>
          </div>

          {/* Thanh tìm kiếm */}
          <div className="row mb-3">
            <div className="col-md-4">
              <input
                type="text"
                className="form-control"
                placeholder="Tìm kiếm theo tên hoặc mã sản phẩm..."
                value={searchText}
                onChange={e => setSearchText(e.target.value)}
              />
            </div>
          </div>

          {/* Summary Stats */}
          {summary && (
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-header">
                  <div className="stat-icon">
                    <i className="fa fa-boxes"></i>
                  </div>
                </div>
                <div className="stat-content">
                  <div className="stat-value">{filteredSummary.totalItems}</div>
                  <div className="stat-label">Tổng số mặt hàng</div>
                </div>
              </div>

              <div className="stat-card">
                <div className="stat-header">
                  <div className="stat-icon">
                    <i className="fa fa-arrow-up text-success"></i>
                  </div>
                </div>
                <div className="stat-content">
                  <div className="stat-value">{formatNumber(filteredSummary.totalTongNhap)}</div>
                  <div className="stat-label">Tổng nhập</div>
                </div>
                <div className="stat-change up">
                  {formatCurrency(filteredSummary.totalGiaTriNhap)}
                </div>
              </div>

              <div className="stat-card">
                <div className="stat-header">
                  <div className="stat-icon">
                    <i className="fa fa-arrow-down text-warning"></i>
                  </div>
                </div>
                <div className="stat-content">
                  <div className="stat-value">{formatNumber(filteredSummary.totalTongXuat)}</div>
                  <div className="stat-label">Tổng xuất</div>
                </div>
                <div className="stat-change down">
                  {formatCurrency(filteredSummary.totalGiaTriXuat)}
                </div>
              </div>

              <div className="stat-card">
                <div className="stat-header">
                  <div className="stat-icon">
                    <i className="fa fa-warehouse text-primary"></i>
                  </div>
                </div>
                <div className="stat-content">
                  <div className="stat-value">{formatNumber(filteredSummary.totalTonCK)}</div>
                  <div className="stat-label">Tồn cuối kỳ</div>
                </div>
                <div className="stat-change up">
                  {formatCurrency(filteredSummary.totalGiaTriCK)}
                </div>
              </div>
            </div>
          )}

          {/* Data Table */}
          {filterType === 'BANHKEM' && (
            <div className="card">
              <div className="card-header">
                <h3>Báo cáo XNT bánh kem</h3>
              </div>
              <div className="card-body">
                {banhKemLoading ? (
                  <div style={{ textAlign: 'center', padding: '40px 0' }}>
                    <i className="fa fa-spinner spinning me-1"></i> Đang tải dữ liệu...
                  </div>
                ) : banhKemData.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '40px 0', color: '#6c757d' }}>
                    Không có dữ liệu XNT bánh kem
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>STT</th>
                          <th>Mã SP</th>
                          <th>Tồn đầu kỳ</th>
                          <th>Nhập điều phối</th>
                          <th>Nhập điều chuyển</th>
                          <th>Xuất bán</th>
                          <th>Xuất điều chuyển</th>
                          <th>Tổng xuất</th>
                          <th>Tồn cuối kỳ</th>
                        </tr>
                      </thead>
                      <tbody>
                        {banhKemData.map((item, idx) => (
                          <tr key={item.MaSP || idx}>
                            <td>{idx + 1}</td>
                            <td>{item.MaSP}</td>
                            <td className="text-end">{item.TonDauKy}</td>
                            <td className="text-end">{item.NhapDieuPhoi}</td>
                            <td className="text-end">{item.NhapDieuChuyen}</td>
                            <td className="text-end">{item.XuatBan}</td>
                            <td className="text-end">{item.XuatDieuChuyen}</td>
                            <td className="text-end">{item.TongXuat}</td>
                            <td className="text-end">{item.Ton}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Chỉ render các bảng khác nếu không phải BANHKEM */}
          {filterType !== 'BANHKEM' && (
            <>
              {/* Data Table */}
              {khoHangData.length > 0 && (
                <div className="card">
                  <div className="card-header">
                    <h3>Báo cáo tồn kho chi tiết</h3>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                      {/* Render data grouped by category */}
                      {getFilteredGroupKeys().map(maNLSP => {
                        const group = groupedData[maNLSP];
                        // Lọc sản phẩm theo searchText
                        const filteredItems = filterItemsBySearch(group.items);
                        if (filteredItems.length === 0) return null;
                        return (
                          <div key={maNLSP} className="category-group mb-4">
                            <h5 className="category-header" style={{
                              backgroundColor: '#f8f9fa',
                              padding: '10px 15px',
                              borderRadius: '5px',
                              marginBottom: '10px',
                              fontWeight: '600',
                              color: '#495057',
                              borderLeft: '5px solid #007bff',
                              position: 'sticky',
                              top: '0px',
                              zIndex: 12
                            }}>
                              {group.name}
                              <span className="badge bg-secondary ms-2" style={{ fontSize: '0.7rem', verticalAlign: 'middle' }}>
                                {filteredItems.length} sản phẩm
                              </span>
                            </h5>
                            
                            <table className="table table-striped">
                              <thead>
                                <tr style={{ 
                                  position: 'sticky', 
                                  top: '48px', 
                                  zIndex: 11, 
                                  backgroundColor: '#f8f9fa',
                                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                }}>
                                  <th style={{ 
                                    backgroundColor: '#f8f9fa', 
                                    borderBottom: '2px solid #dee2e6',
                                    padding: '12px 8px',
                                    fontSize: '13px',
                                    fontWeight: '600'
                                  }}>STT</th>
                                  <th style={{ 
                                    backgroundColor: '#f8f9fa', 
                                    borderBottom: '2px solid #dee2e6',
                                    padding: '12px 8px',
                                    fontSize: '13px',
                                    fontWeight: '600'
                                  }}>Mã NL</th>
                                  <th style={{ 
                                    backgroundColor: '#f8f9fa', 
                                    borderBottom: '2px solid #dee2e6',
                                    padding: '12px 8px',
                                    fontSize: '13px',
                                    fontWeight: '600'
                                  }}>Tên sản phẩm</th>
                                  <th style={{ 
                                    backgroundColor: '#f8f9fa', 
                                    borderBottom: '2px solid #dee2e6',
                                    padding: '12px 8px',
                                    fontSize: '13px',
                                    fontWeight: '600'
                                  }}>ĐVT</th>
                                  <th style={{ 
                                    backgroundColor: '#f8f9fa', 
                                    borderBottom: '2px solid #dee2e6',
                                    padding: '12px 8px',
                                    fontSize: '13px',
                                    fontWeight: '600'
                                  }}>Tồn đầu kỳ</th>
                                  <th style={{ 
                                    backgroundColor: '#f8f9fa', 
                                    borderBottom: '2px solid #dee2e6',
                                    padding: '12px 8px',
                                    fontSize: '13px',
                                    fontWeight: '600'
                                  }}>GT đầu kỳ</th>
                                  {!showSplitNhap ? (
                                    <th
                                      style={{ 
                                        cursor: 'pointer', 
                                        textDecoration: 'underline',
                                        backgroundColor: '#f8f9fa',
                                        borderBottom: '2px solid #dee2e6',
                                        padding: '12px 8px',
                                        fontSize: '13px',
                                        fontWeight: '600'
                                      }}
                                      onClick={() => setShowSplitNhap(true)}
                                      title="Nhấn để xem chi tiết nhập điều phối/điều chuyển"
                                    >
                                      Tổng nhập
                                    </th>
                                  ) : (
                                    <>
                                      <th
                                        style={{ 
                                          cursor: 'pointer', 
                                          textDecoration: 'underline',
                                          backgroundColor: '#f8f9fa',
                                          borderBottom: '2px solid #dee2e6',
                                          padding: '12px 8px',
                                          fontSize: '13px',
                                          fontWeight: '600'
                                        }}
                                        onClick={() => setShowSplitNhap(false)}
                                        title="Nhấn để gộp lại"
                                      >
                                        Nhập điều phối
                                      </th>
                                      <th
                                        style={{ 
                                          cursor: 'pointer', 
                                          textDecoration: 'underline',
                                          backgroundColor: '#f8f9fa',
                                          borderBottom: '2px solid #dee2e6',
                                          padding: '12px 8px',
                                          fontSize: '13px',
                                          fontWeight: '600'
                                        }}
                                        onClick={() => setShowSplitNhap(false)}
                                        title="Nhấn để gộp lại"
                                      >
                                        Nhập điều chuyển
                                      </th>
                                    </>
                                  )}
                                  {!showSplitGiaTriNhap ? (
                                    <th
                                      style={{ 
                                        cursor: 'pointer', 
                                        textDecoration: 'underline',
                                        backgroundColor: '#f8f9fa',
                                        borderBottom: '2px solid #dee2e6',
                                        padding: '12px 8px',
                                        fontSize: '13px',
                                        fontWeight: '600'
                                      }}
                                      onClick={() => setShowSplitGiaTriNhap(true)}
                                      title="Nhấn để xem chi tiết GT nhập điều phối/điều chuyển"
                                    >
                                      GT nhập
                                    </th>
                                  ) : (
                                    <>
                                      <th
                                        style={{ 
                                          cursor: 'pointer', 
                                          textDecoration: 'underline',
                                          backgroundColor: '#f8f9fa',
                                          borderBottom: '2px solid #dee2e6',
                                          padding: '12px 8px',
                                          fontSize: '13px',
                                          fontWeight: '600'
                                        }}
                                        onClick={() => setShowSplitGiaTriNhap(false)}
                                        title="Nhấn để gộp lại"
                                      >
                                        GT nhập ĐP
                                      </th>
                                      <th
                                        style={{ 
                                          cursor: 'pointer', 
                                          textDecoration: 'underline',
                                          backgroundColor: '#f8f9fa',
                                          borderBottom: '2px solid #dee2e6',
                                          padding: '12px 8px',
                                          fontSize: '13px',
                                          fontWeight: '600'
                                        }}
                                        onClick={() => setShowSplitGiaTriNhap(false)}
                                        title="Nhấn để gộp lại"
                                      >
                                        GT nhập ĐC
                                      </th>
                                    </>
                                  )}
                                  {!showSplitXuat ? (
                                    <th
                                      style={{ 
                                        cursor: 'pointer', 
                                        textDecoration: 'underline',
                                        backgroundColor: '#f8f9fa',
                                        borderBottom: '2px solid #dee2e6',
                                        padding: '12px 8px',
                                        fontSize: '13px',
                                        fontWeight: '600'
                                      }}
                                      onClick={() => setShowSplitXuat(true)}
                                      title="Nhấn để xem chi tiết xuất/hủy/điều chuyển"
                                    >
                                      Tổng xuất
                                    </th>
                                  ) : (
                                    <>
                                      <th
                                        style={{ 
                                          cursor: 'pointer', 
                                          textDecoration: 'underline',
                                          backgroundColor: '#f8f9fa',
                                          borderBottom: '2px solid #dee2e6',
                                          padding: '12px 8px',
                                          fontSize: '13px',
                                          fontWeight: '600'
                                        }}
                                        onClick={() => setShowSplitXuat(false)}
                                        title="Nhấn để gộp lại"
                                      >
                                        Xuất bán
                                      </th>
                                      <th
                                        style={{ 
                                          cursor: 'pointer', 
                                          textDecoration: 'underline',
                                          backgroundColor: '#f8f9fa',
                                          borderBottom: '2px solid #dee2e6',
                                          padding: '12px 8px',
                                          fontSize: '13px',
                                          fontWeight: '600'
                                        }}
                                        onClick={() => setShowSplitXuat(false)}
                                        title="Nhấn để gộp lại"
                                      >
                                        Tổng hủy
                                      </th>
                                      <th
                                        style={{ 
                                          cursor: 'pointer', 
                                          textDecoration: 'underline',
                                          backgroundColor: '#f8f9fa',
                                          borderBottom: '2px solid #dee2e6',
                                          padding: '12px 8px',
                                          fontSize: '13px',
                                          fontWeight: '600'
                                        }}
                                        onClick={() => setShowSplitXuat(false)}
                                        title="Nhấn để gộp lại"
                                      >
                                        Xuất điều chuyển
                                      </th>
                                    </>
                                  )}
                                  {!showSplitGiaTriXuat ? (
                                    <th
                                      style={{ 
                                        cursor: 'pointer', 
                                        textDecoration: 'underline',
                                        backgroundColor: '#f8f9fa',
                                        borderBottom: '2px solid #dee2e6',
                                        padding: '12px 8px',
                                        fontSize: '13px',
                                        fontWeight: '600'
                                      }}
                                      onClick={() => setShowSplitGiaTriXuat(true)}
                                      title="Nhấn để xem chi tiết GT xuất/hủy/điều chuyển"
                                    >
                                      GT xuất
                                    </th>
                                  ) : (
                                    <>
                                      <th
                                        style={{ 
                                          cursor: 'pointer', 
                                          textDecoration: 'underline',
                                          backgroundColor: '#f8f9fa',
                                          borderBottom: '2px solid #dee2e6',
                                          padding: '12px 8px',
                                          fontSize: '13px',
                                          fontWeight: '600'
                                        }}
                                        onClick={() => setShowSplitGiaTriXuat(false)}
                                        title="Nhấn để gộp lại"
                                      >
                                        GT xuất bán
                                      </th>
                                      <th
                                        style={{ 
                                          cursor: 'pointer', 
                                          textDecoration: 'underline',
                                          backgroundColor: '#f8f9fa',
                                          borderBottom: '2px solid #dee2e6',
                                          padding: '12px 8px',
                                          fontSize: '13px',
                                          fontWeight: '600'
                                        }}
                                        onClick={() => setShowSplitGiaTriXuat(false)}
                                        title="Nhấn để gộp lại"
                                      >
                                        GT hủy
                                      </th>
                                      <th
                                        style={{ 
                                          cursor: 'pointer', 
                                          textDecoration: 'underline',
                                          backgroundColor: '#f8f9fa',
                                          borderBottom: '2px solid #dee2e6',
                                          padding: '12px 8px',
                                          fontSize: '13px',
                                          fontWeight: '600'
                                        }}
                                        onClick={() => setShowSplitGiaTriXuat(false)}
                                        title="Nhấn để gộp lại"
                                      >
                                        GT xuất ĐC
                                      </th>
                                    </>
                                  )}
                                  <th style={{ 
                                    backgroundColor: '#f8f9fa', 
                                    borderBottom: '2px solid #dee2e6',
                                    padding: '12px 8px',
                                    fontSize: '13px',
                                    fontWeight: '600'
                                  }}>Tồn cuối kỳ</th>
                                  <th style={{ 
                                    backgroundColor: '#f8f9fa', 
                                    borderBottom: '2px solid #dee2e6',
                                    padding: '12px 8px',
                                    fontSize: '13px',
                                    fontWeight: '600'
                                  }}>GT cuối kỳ</th>
                                </tr>
                              </thead>
                              <tbody>
                                {filteredItems.map((item, index) => {
                                  const transferInfo = getTransferDataForProduct(item.MaNL);
                                  return (
                                    <tr key={`${maNLSP}-${item.MaNL || index}`}>
                                      <td>{item.STT}</td>
                                      <td>{item.MaNL}</td>
                                      <td>{item.Ten_SP}</td>
                                      <td>{item.DVT_SP}</td>
                                      <td className="text-end">{formatNumber(item.TonDauKy)}</td>
                                      <td className="text-end">{formatCurrency(item.GiaTriDauKy)}</td>
                                      {!showSplitNhap ? (
                                        <td className="text-end">
                                          {formatNumber((item.TongNhap || 0) + transferInfo.nhapDieuChuyen)}
                                        </td>
                                      ) : (
                                        <>
                                          <td className="text-end">{formatNumber(item.TongNhap)}</td>
                                          <td className="text-end">{formatNumber(transferInfo.nhapDieuChuyen)}</td>
                                        </>
                                      )}
                                      {!showSplitGiaTriNhap ? (
                                        <td className="text-end">
                                          {formatCurrency((item.GiaTriNhap || 0) + transferInfo.giaTriNhapDieuChuyen)}
                                        </td>
                                      ) : (
                                        <>
                                          <td className="text-end">{formatCurrency(item.GiaTriNhap)}</td>
                                          <td className="text-end">{formatCurrency(transferInfo.giaTriNhapDieuChuyen)}</td>
                                        </>
                                      )}
                                      {!showSplitXuat ? (
                                        <td className="text-end">
                                          {formatNumber((item.TongXuat || 0) + (item.TongHuy || 0) + transferInfo.xuatDieuChuyen)}
                                        </td>
                                      ) : (
                                        <>
                                          <td className="text-end">{formatNumber(item.TongXuat)}</td>
                                          <td className="text-end">{formatNumber(item.TongHuy)}</td>
                                          <td className="text-end">{formatNumber(transferInfo.xuatDieuChuyen)}</td>
                                        </>
                                      )}
                                      {!showSplitGiaTriXuat ? (
                                        <td className="text-end">
                                          {formatCurrency((item.GiaTriXuat || 0) + (item.GiaTriHuy || 0) + transferInfo.giaTriXuatDieuChuyen)}
                                        </td>
                                      ) : (
                                        <>
                                          <td className="text-end">{formatCurrency(item.GiaTriXuat)}</td>
                                          <td className="text-end">{formatCurrency(item.GiaTriHuy)}</td>
                                          <td className="text-end">{formatCurrency(transferInfo.giaTriXuatDieuChuyen)}</td>
                                        </>
                                      )}
                                      <td className="text-end font-weight-bold">{formatNumber(item.TonCK)}</td>
                                      <td className="text-end font-weight-bold">{formatCurrency(item.GiaTriCK)}</td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                              <tfoot>
                                <tr style={{ background: '#f0f8ff', fontWeight: 'bold' }}>
                                  <td colSpan="4" className="text-end">Tổng nhóm {group.name}:</td>
                                  <td className="text-end">
                                    {formatNumber(group.items.reduce((sum, item) => sum + (item.TonDauKy || 0), 0))}
                                  </td>
                                  <td className="text-end">
                                    {formatCurrency(group.items.reduce((sum, item) => sum + (item.GiaTriDauKy || 0), 0))}
                                  </td>
                                  {!showSplitNhap ? (
                                    <td className="text-end">
                                      {formatNumber(group.items.reduce((sum, item) => {
                                        const transferInfo = getTransferDataForProduct(item.MaNL);
                                        return sum + (item.TongNhap || 0) + transferInfo.nhapDieuChuyen;
                                      }, 0))}
                                    </td>
                                  ) : (
                                    <>
                                      <td className="text-end">
                                        {formatNumber(group.items.reduce((sum, item) => sum + (item.TongNhap || 0), 0))}
                                      </td>
                                      <td className="text-end">
                                        {formatNumber(group.items.reduce((sum, item) => {
                                          const transferInfo = getTransferDataForProduct(item.MaNL);
                                          return sum + transferInfo.nhapDieuChuyen;
                                        }, 0))}
                                      </td>
                                    </>
                                  )}
                                  {!showSplitGiaTriNhap ? (
                                    <td className="text-end">
                                      {formatCurrency(group.items.reduce((sum, item) => {
                                        const transferInfo = getTransferDataForProduct(item.MaNL);
                                        return sum + (item.GiaTriNhap || 0) + transferInfo.giaTriNhapDieuChuyen;
                                      }, 0))}
                                    </td>
                                  ) : (
                                    <>
                                      <td className="text-end">
                                        {formatCurrency(group.items.reduce((sum, item) => sum + (item.GiaTriNhap || 0), 0))}
                                      </td>
                                      <td className="text-end">
                                        {formatCurrency(group.items.reduce((sum, item) => {
                                          const transferInfo = getTransferDataForProduct(item.MaNL);
                                          return sum + transferInfo.giaTriNhapDieuChuyen;
                                        }, 0))}
                                      </td>
                                    </>
                                  )}
                                  {!showSplitXuat ? (
                                    <td className="text-end">
                                      {formatNumber(group.items.reduce((sum, item) => {
                                        const transferInfo = getTransferDataForProduct(item.MaNL);
                                        return sum + (item.TongXuat || 0) + (item.TongHuy || 0) + transferInfo.xuatDieuChuyen;
                                      }, 0))}
                                    </td>
                                  ) : (
                                    <>
                                      <td className="text-end">
                                        {formatNumber(group.items.reduce((sum, item) => sum + (item.TongXuat || 0), 0))}
                                      </td>
                                      <td className="text-end">
                                        {formatNumber(group.items.reduce((sum, item) => sum + (item.TongHuy || 0), 0))}
                                      </td>
                                      <td className="text-end">
                                        {formatNumber(group.items.reduce((sum, item) => {
                                          const transferInfo = getTransferDataForProduct(item.MaNL);
                                          return sum + transferInfo.xuatDieuChuyen;
                                        }, 0))}
                                      </td>
                                    </>
                                  )}
                                  {!showSplitGiaTriXuat ? (
                                    <td className="text-end">
                                      {formatCurrency(group.items.reduce((sum, item) => {
                                        const transferInfo = getTransferDataForProduct(item.MaNL);
                                        return sum + (item.GiaTriXuat || 0) + (item.GiaTriHuy || 0) + transferInfo.giaTriXuatDieuChuyen;
                                      }, 0))}
                                    </td>
                                  ) : (
                                    <>
                                      <td className="text-end">
                                        {formatCurrency(group.items.reduce((sum, item) => sum + (item.GiaTriXuat || 0), 0))}
                                      </td>
                                      <td className="text-end">
                                        {formatCurrency(group.items.reduce((sum, item) => sum + (item.GiaTriHuy || 0), 0))}
                                      </td>
                                      <td className="text-end">
                                        {formatCurrency(group.items.reduce((sum, item) => {
                                          const transferInfo = getTransferDataForProduct(item.MaNL);
                                          return sum + transferInfo.giaTriXuatDieuChuyen;
                                        }, 0))}
                                      </td>
                                    </>
                                  )}
                                  <td className="text-end">
                                    {formatNumber(group.items.reduce((sum, item) => sum + (item.TonCK || 0), 0))}
                                  </td>
                                  <td className="text-end">
                                    {formatCurrency(group.items.reduce((sum, item) => sum + (item.GiaTriCK || 0), 0))}
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        );
                      })}
                      

                      {/* Main total */}
                      {khoHangData.length > 0 && (
                        <div style={{ position: 'sticky', bottom: 0, backgroundColor: '#fff', zIndex: 10, boxShadow: '0 -2px 4px rgba(0,0,0,0.1)' }}>
                          <table className="table">
                            <tfoot>
                              <tr style={{ background: '#f8f9fa', fontWeight: 'bold' }}>
                                <td colSpan="4" className="text-end">TỔNG CỘNG TẤT CẢ:</td>
                                <td className="text-end">{formatNumber(filteredSummary.totalTonCK)}</td>
                                <td className="text-end">{formatCurrency(filteredSummary.totalGiaTriCK)}</td>
                                <td className="text-end">{formatNumber(filteredSummary.totalTongNhap + filteredSummary.totalNhapDieuChuyen)}</td>
                                <td className="text-end">{formatCurrency(filteredSummary.totalGiaTriNhap + filteredSummary.totalGiaTriNhapDieuChuyen)}</td>
                                {!showSplitXuat ? (
                                  <td className="text-end">
                                    {formatNumber(filteredSummary.totalTongXuat + filteredSummary.totalXuatDieuChuyen)}
                                  </td>
                                ) : (
                                  <>
                                    <td className="text-end">{formatNumber(filteredSummary.totalTongXuat)}</td>
                                    <td className="text-end">{formatNumber(filteredSummary.totalXuatDieuChuyen)}</td>
                                  </>
                                )}
                                {!showSplitGiaTriXuat ? (
                                  <td className="text-end">
                                    {formatCurrency(filteredSummary.totalGiaTriXuat + filteredSummary.totalGiaTriXuatDieuChuyen)}
                                  </td>
                                ) : (
                                  <>
                                    <td className="text-end">{formatCurrency(filteredSummary.totalGiaTriXuat)}</td>
                                    <td className="text-end">{formatCurrency(filteredSummary.totalGiaTriXuatDieuChuyen)}</td>
                                  </>
                                )}
                                <td className="text-end">{formatNumber(filteredSummary.totalTonCK)}</td>
                                <td className="text-end">{formatCurrency(filteredSummary.totalGiaTriCK)}</td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </>
          )}

          {/* Empty State */}
          {!loading && khoHangData.length === 0 && !error && (
            <div className="card">
              <div className="card-body text-center" style={{ padding: '60px 20px' }}>
                <div className="stat-icon" style={{ fontSize: '48px', margin: '0 auto 20px', opacity: 0.5 }}>
                  <i className="fa fa-warehouse"></i>
                </div>
                <h3 style={{ color: '#6c757d', marginBottom: '8px' }}>Chưa có dữ liệu</h3>
                <p style={{ color: '#6c757d', marginBottom: '0' }}>
                  Vui lòng chọn bộ lọc và nhấn "Tìm kiếm" để xem báo cáo kho hàng
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuanLyKho;